<template>
    <svg width="96" height="96" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
        <!-- @vue-ignore -->
        <g fill="none" fill-rule="evenodd" stroke="currentColor">
            <!-- @vue-ignore -->
            <circle stroke-width="2" cx="48" cy="48" r="39" />
            <!-- @vue-ignore -->
            <path
                d="M69.667 38.788c-5.896-4.96-13.491-7.947-21.78-7.947-8.28 0-15.867 2.98-21.76 7.931M63.329 46.992a24.076 24.076 0 0 0-15.442-5.58 24.076 24.076 0 0 0-15.43 5.572M56.98 55.19a14.442 14.442 0 0 0-9.093-3.207 14.442 14.442 0 0 0-9.083 3.2"
                stroke-width="2"
            />
            <!-- @vue-ignore -->
            <circle stroke-width="3.429" fill="currentColor" fill-rule="nonzero" cx="48" cy="65.54" r="1.175" />
        </g>
    </svg>
</template>
